import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_5o8ey581fk: FaireBrandEntity = {
  token: "b_5o8ey581fk",
  type: "brand",
  name: "DM Merchandising",
  avatarUrl:
    "https://cdn.faire.com/fastly/899f64cd5f9bfdc775e6f06e88378fdad002fbf57713eb05be0aefb849edd588.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/ecf19c5628c7e4b4baac8e1e9c9f4956d8c8c53fe0cf9c7ca2fc417731bc2440.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/899f64cd5f9bfdc775e6f06e88378fdad002fbf57713eb05be0aefb849edd588.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/ecf19c5628c7e4b4baac8e1e9c9f4956d8c8c53fe0cf9c7ca2fc417731bc2440.jpeg",
  location: "Elmhurst , IL, USA",
  minimumOrderDollars: 150,
  rating: 4.9,
  reviewCount: 1867,
  isTopShop: true,
  isInsider: true,
  description:
    "DM has been voted the 2025 Manufacturer of the Year! This is the third time in the past 6 years and the only 3-time winner in the 74 years of this award.\n\nAt DM, we create products that bring success to those who sell them, and joy to those who buy them. Using our expertise in merchandising, we introduce turn-key products and programs to a wide network of retailers. We envision, fulfill, and distribute all under one roof, and all while having fun. Our design and product development teams are constantly creating innovative merchandise in the latest styles and patterns, complete with retail-ready displays for maximum turnaround, and unparalleled consumer satisfaction.\n\nDM has been in the gift industry for over 30 years, expanding from jewelry to the most diverse line of programs in the business! DM is not your typical manufacturer – we’ve created thousands of products under hundreds of brands with bright, contemporary packaging and modern, functional displays. In our showroom you’ll find everything from fashion and fitness apparel, footwear, and cold-weather accessories, to kitchenware, tech items, novelty and seasonal merchandise. Partnering with DM is like working with 30 different vendors, all under one roof!\n\nWe’re passionate supporters of shopping local, which is why we partner exclusively with brick-and-mortar retailers. ",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:44:33.227Z",
    importedBy: "entity-db-cli",
  },
};
